import { type LegalDocumentGroup } from './groupLegalDocuments';

export type AgreementsRecord = Record<string, boolean> | undefined;

// Walks the form's agreement record + the group catalog and returns every
// document `uuid` that should be signed: every doc (anchor + linked) inside
// every group whose anchor checkbox is currently checked. Used to populate
// `signed_documents` on the createUser payload and the draft's
// `signedDocuments` field for restore-on-return.
export function deriveSignedDocuments(
  agreements: AgreementsRecord,
  legalGroups: LegalDocumentGroup[]
): { uuid: string }[] {
  return legalGroups
    .filter((g) => agreements?.[g.anchor.uuid] === true)
    .flatMap((g) => [g.anchor, ...g.linked])
    .map((d) => ({ uuid: d.uuid }));
}

// Whether the group anchored on a doc with the given server-defined `key` is
// checked. Used for the legacy customerProfile booleans
// (`termsAndConditionsAccepted` / `informedConsentAccepted`) which live
// alongside `signedDocuments` on the payload.
export function isLegalKeyAgreed(
  agreements: AgreementsRecord,
  legalGroups: LegalDocumentGroup[],
  key: string
): boolean {
  const group = legalGroups.find((g) => g.anchor.key === key);
  return group ? agreements?.[group.anchor.uuid] === true : false;
}
